import React from 'react';
import "./FailurePage.css"; // Import the CSS file

const FailurePage = () => {
  return (
    <div className="failure-container">
      <div className="card">
          <img
            className="icon fe"
            src="https://res.cloudinary.com/vimplay/image/upload/v1743184210/fe_cdn/fe_logo_txv8hm.svg"
            alt=""
          />
        <h1 className="pfailed">Paiement échoué</h1>
        <p className="message2">Malheureusement, votre paiement n'a pas réussi.</p>
        <div className="info-box2">
          <p className="info2">
            Veuillez réessayer ou contacter le support pour obtenir de l'aide.
          </p>
        </div>
        <div className="contact">
          <p className='ct'>Vous avez des questions? Contactez-nous</p>
          <a href="mailto:freelancediteur@gmail.com" className="email">
          freelancediteur@gmail.com
          </a>
        </div>
        <div className="retry-btn">
          <p className="button2" >Veuillez réessayer</p>
          {/*<a href="freelancediteur://ebook_app/profile" className="button">
            Retour à l'application
          </a>*/}
        </div>
      </div>
    </div>
  );
};

export default FailurePage;